import { API } from 'aws-amplify';
import { AccountRecoveryAttempt } from '../data_types/account-recovery-attempt';
import { getAuthHeaders } from './auth';

const createAccountRecoveryAttempt = async (request: AccountRecoveryAttempt): Promise<void> => {
    return API.post('membership', '/account-recovery-attempt', {
        headers: getAuthHeaders(),
        body: {
            ...request,
        },
    });
};

export default createAccountRecoveryAttempt;
